// extracted by mini-css-extract-plugin
export default {"taskButton":"taskButton___q891n","taskButtonContainer":"taskButtonContainer___Rb4au"};